























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { getStaticConfiguration } from "@/config/app";

@Component
export default class SpecialNavbar extends Vue {
  @Prop({ type: String }) navClass!: string;
  home = "";
  mounted(): void {
    getStaticConfiguration().then(
      (config) => (this.home = config.HOME_ROUTE || "news")
    );
  }
}
